function getThemeValue(name, props, values) {
  const value = props.theme && props.theme[name];

  let themeValue;

  if (typeof value === 'function') {
    themeValue = value(values);
  } else if (values[value]) {
    themeValue = values[value];
  } else {
    themeValue = values.none;
  }

  if (typeof themeValue === 'function') {
    return themeValue(props);
  }
  return themeValue;
}

function theme(name, values) {
  return props => getThemeValue(name, props, values);
}

theme.variants = (name, prop, values) => props => {
  const variant = props[prop] && values[props[prop]];
  return variant && getThemeValue(name, props, variant);
};

export default theme;
